function initBlogLoadMoreSections() {
  const sections = document.querySelectorAll("[data-blog-load-more-section]");
  if (!sections.length) return;

  sections.forEach((section) => {
    if (section.dataset.blogLoadMoreInitialized === "true") return;
    section.dataset.blogLoadMoreInitialized = "true";
    new BlogLoadMoreSection(section);
  });
}

class BlogLoadMoreSection {
  constructor(section) {
    this.section = section;
    this.grid = section.querySelector("[data-blog-articles]");
    this.pagination = section.querySelector("[data-blog-load-more-pagination]");
    this.button = section.querySelector("[data-blog-load-more-button]");
    this.isLoading = false;

    if (!this.grid || !this.button) return;
    this.button.addEventListener("click", (event) => this.loadNextPage(event));
  }

  async loadNextPage(event) {
    event.preventDefault();
    if (this.isLoading || !this.button?.href) return;

    const url = this.button.href;
    this.setLoading(true);

    try {
      const response = await fetch(url, {
        headers: { "X-Requested-With": "XMLHttpRequest" },
      });
      if (!response.ok) throw new Error("Unable to load articles");

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, "text/html");
      const nextGrid = doc.querySelector("[data-blog-articles]");
      const nextButton = doc.querySelector("[data-blog-load-more-button]");

      if (!nextGrid) throw new Error("Article grid not found");

      Array.from(nextGrid.children).forEach((item) => {
        this.grid.appendChild(item);
      });

      if (nextButton) {
        this.button.href = nextButton.href;
        this.button.textContent = nextButton.textContent.trim();
        this.setLoading(false);
        return;
      }

      this.removePagination();
    } catch (error) {
      window.location.href = url;
    }
  }

  setLoading(isLoading) {
    this.isLoading = isLoading;
    if (!this.button) return;

    this.button.setAttribute("aria-busy", String(isLoading));
    this.button.setAttribute("aria-disabled", String(isLoading));

    if (isLoading) {
      this.button.dataset.label = this.button.textContent.trim();
      this.button.textContent = "LOADING ARTICLES";
      return;
    }

    this.button.textContent = this.button.dataset.label || this.button.textContent;
    delete this.button.dataset.label;
  }

  removePagination() {
    if (this.pagination) {
      this.pagination.remove();
    }

    this.pagination = null;
    this.button = null;
    this.isLoading = false;
  }
}

initBlogLoadMoreSections();
